import HtmlPreview from '../../../../../shared/html-preview';
import { WelcomeTemplateEntity } from '../../../../../../types';
import SharedReviewLayout, {
  ReviewSection,
} from '../../../../../shared/shared-review-layout-new';

interface StepWelcomeTemplateReviewProps {
  selectedTemplate: Partial<WelcomeTemplateEntity>;
  isDrawer?: boolean;
}

export default function StepWelcomeTemplateReview({
  selectedTemplate,
  isDrawer = false,
}: StepWelcomeTemplateReviewProps) {
  const sections: ReviewSection[] = [
    {
      title: 'Basic Information',
      leftItems: [
        { label: 'Template Name', value: selectedTemplate.templateName },
        {
          label: 'Description',
          value: selectedTemplate.description || '',
          isVisible: !!selectedTemplate.description,
        },
        {
          label: 'Default',
          value: selectedTemplate.default,
        },
      ],
    },
    {
      title: 'Email Content',
      leftWidth: {
        columnWidth: 10,
      },
      leftItems: [
        {
          label: 'Subject',
          value: selectedTemplate.templateSubject || '',
        },
        {
          value: (
            <HtmlPreview
              html={selectedTemplate.templateHtml || ''}
              title="Body"
            />
          ),
        },
      ],
    },
  ];
  return <SharedReviewLayout leftSections={sections} isDrawer={isDrawer} />;
}
